module.exports = __webpack_public_path__ + "img/register01.03daa16d.png";